module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Regular.ttf
// module id = 64
// module chunks = 8